import { Get_OSTAM, Get_SHAR, Get_COUNTRY, SIGN_REQUEST } from "./actionTypes";
import { alertMessenger } from "./alertAction";
import CommonAxios from '../../axios/AxiosCommon';
import Refundaxios from '../../axios/Customer';

export const Regionresult = (data, Type) => {
    if (Type === 1) return {
        type: Get_COUNTRY,
        countryList: data
    }

    if (Type === 2) return {
        type: Get_OSTAM,
        ostanList: data
    }

    if (Type === 3) return {
        type: Get_SHAR,
        shahrList: data
    }
}



export const RequestForRegion = (Type = 2, ParentId = 1) => {
    return dispatch => {
        CommonAxios({
            method: 'get',
            url: '/GetRegion',
            params: {
                "Type": Type,
                "ParentId": ParentId,
            },
        })
            .then(response => {
                response.data.Result.unshift(
                    {
                        Id: 0,
                        Name: "",
                        CityId: 0,
                        City: null,
                        ProvinceId: 0,
                        Code: null,
                        NameEn: null,
                        Province: null,
                    }
                )
                dispatch(Regionresult(response.data.Result, Type))
            })
            .catch(error => {
                dispatch(alertMessenger(error.response.data.Message))
            })
            .catch(() => {
                dispatch(alertMessenger("خطا در ارتباط با شبکه"))
            })
    }
}


export const SignResult = (data = false) => {
    return {
        type: SIGN_REQUEST,
        signResult: data
    }
}

export const signRequest = (data) => {
    return dispatch => {
        Refundaxios({
            method: 'post',
            url: '/AddRequestSign',
            data: {
                "AgencyName": data.AgencyName,
                "AttachmentId": data.AttachmentId,
                "CityId": data.CityId,
                "Phone": data.Phone,
                "AgencyFax": data.AgencyFax,
                "AgencyAddress": data.AgencyAddress,
                "AgencyEmail": data.AgencyEmail,
                "ManagerFullName": data.ManagerFullName,
                "ManagerMobile": data.ManagerMobile,
                "RepresentativeFullName": data.RepresentativeFullName,
                "RepresentativeMobile": data.RepresentativeMobile,
                "UserName": data.UserName,
                "Password": data.Password,
                "Description": data.Description,
            }
        })
            .then(response => {
                dispatch(alertMessenger(response.data.Message))
                dispatch(SignResult(true))
            })
            .catch(error => {
                dispatch(alertMessenger(error.response.data.Message))
                dispatch(SignResult(false))
            })
            .catch(() => {
                dispatch(alertMessenger("خطا در ارتباط با شبکه"))
                dispatch(SignResult(false))
            })
    }
} 
